import React               from 'react';
import styled              from 'styled-components';
import {
  FormControlLabel,
  Switch as MuiSwitch,
}                          from '@material-ui/core';
import { SwitchProps }     from '@material-ui/core/Switch';
import { FieldInputProps } from 'formik';

const StyledFormControlLabel = styled(FormControlLabel)`
  && {
    margin-left: 0;

    > span:last-child {
      font-size   : 18px;
      font-weight : 300;
      margin-left : 5px;
    }

    .MuiSwitch-root {
      width   : 55px;
      height  : 34.5px;
      padding : 8px;
    }

    .MuiSwitch-switchBase {
      padding: 10px;
    }

    .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
      opacity: 1;
    }

    .MuiSwitch-track {
      border-radius    : 12px;
      background-color : ${({ bgcolor, theme: { backgroundColor } }: any): string => backgroundColor[bgcolor]};
    }

    .MuiSwitch-thumb {
      width  : 14px;
      height : 14px;
    }
  }
` as any;

export interface ISwitchProps extends SwitchProps {
  field    : FieldInputProps<any>;
  label?   : string;
  bgcolor? : string;
}

export const Switch = ({
  label,
  field,
  bgcolor,
  disabled = false,
  ...props
}: ISwitchProps): JSX.Element => (
  <StyledFormControlLabel
    disabled       = {disabled}
    value          = {field.value}
    label          = {label}
    bgcolor        = {bgcolor}
    labelPlacement = "end"
    control        = {(
      <MuiSwitch
        checked={field.value}
        {...field}
        {...props}
      />
    )}
  />
);

Switch.defaultProps = {
  color         : 'default',
  bgcolor       : 'blue',
  disableRipple : true,
};
